import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "./components/navigation/NavBar";
import { useContext, useEffect, lazy, Suspense } from "react";
import { UserContext } from "./context/userContext";
import Footer from "./components/site-footer/Footer";
import { Navigate } from "react-router-dom";
import { NextUIProvider } from "@nextui-org/react";
import * as React from "react";
import { SpinnerContext } from "./context/spinnerContext";
import { getCurrentUser } from "./auth/authApi";
import AdminRoute from "./auth/AdminRoute";
import VefiChatGlobal from "./components/VefiChatGlobal";
import AnalyticsTracker from "./components/SEO/AnalyticsTracker";


// Lazy loading of page components to reduce initial bundle size
const Home = lazy(() => import("./pages/Home"));
const LoginApp = lazy(() => import("./components/navigation/Login"));
const Publicacion = lazy(() => import("./pages/Publicacion"));
const CargaEmpresa = lazy(() => import("./pages/formulario-empresa/CargaEmpresa"));
const EditarEmpresa = lazy(() => import("./pages/formulario-empresa/EditarEmpresa"));
const PaginaEmpresa = lazy(() => import("./pages/PaginaEmpresa"));
const Reparacion = lazy(() => import("./pages/categorias/Reparacion"));
const Venta = lazy(() => import("./pages/categorias/Venta"));
const ServiciosComplementarios = lazy(() => import("./pages/categorias/ServiciosComplementarios"));
const Emergencias = lazy(() => import("./pages/categorias/Emergencias"));
const AvisoLegal = lazy(() => import("./components/site-footer/AvisoLegal"));
const PoliticaPrivacidad = lazy(() => import("./components/site-footer/PoliticaPrivacidad"));
const Dropdown = lazy(() => import("./components/navigation/Dropdown"));
const MisEmpresas = lazy(() => import("./components/dashboard/MisEmpresas"));
const Dashboard = lazy(() => import("./components/dashboard/Dashboard"));
const Informe = lazy(() => import("./components/dashboard/Informe"));
const Calendario = lazy(() => import("./components/dashboard/Calendario"));
const Favoritos = lazy(() => import("./components/dashboard/Favoritos"));

const Admin = lazy(() => import("./components/dashboard/Admin"));
const Insights = lazy(() => import("./components/dashboard/Insights"));
const Perfil = lazy(() => import("./components/dashboard/Perfil"));
const DebugAuth = lazy(() => import("./pages/DebugAuth"));

function App() {
  const { updateUserData, setShow, userData, show } = useContext(UserContext);
  const { spinner } = useContext(SpinnerContext);

  useEffect(() => {
    const verifiLog = async () => {
      try {
        const user = await getCurrentUser();
        updateUserData(
          user || { email: "", name: "", isLogged: false, role: "user" }
        );
      } catch (error) {
        console.error("Error al recuperar la sesión:", error);
        updateUserData({ email: "", name: "", isLogged: false, role: "user" });
      } finally {
        setShow(true);
      }
    };
    verifiLog();
    // eslint-disable-next-line
  }, []);

  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <NextUIProvider>
        {spinner}
        <NavBar />
        <Suspense fallback={<div className="loading-spinner"></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginApp />} />
            <Route path="/Publicacion" element={<Publicacion />} />
            <Route path="/Reparacion" element={<Reparacion />} />
            <Route path="/Venta" element={<Venta />} />
            <Route path="/ServiciosComplementarios" element={<ServiciosComplementarios />} />
            <Route path="/Emergencias" element={<Emergencias />} />
            <Route path="/PoliticaPrivacidad" element={<PoliticaPrivacidad />} />
            <Route path="/AvisoLegal" element={<AvisoLegal />} />
            <Route path="/debug-auth" element={<DebugAuth />} />
            <Route path="/Dropdown" element={<Dropdown />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/Informe" element={<Informe />} />
            <Route path="/Calendario" element={<Calendario />} />
            <Route path="/Favoritos" element={<Favoritos />} />
            <Route path="/NegociosDash" element={<MisEmpresas />} />
            <Route
              path="/admin/insights"
              element={
                <AdminRoute>
                  <Insights />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
            <Route
              path="/MisEmpresas"
              element={
                ((!show || userData.isLogged) && <MisEmpresas />) ||
                ((show || !userData.isLogged) && <Navigate to="/" />)
              }
            />

            <Route
              path="/EditarEmpresa/:id?"
              element={
                ((!show || userData.isLogged) && <EditarEmpresa />) ||
                ((show || !userData.isLogged) && <Navigate to="/" />)
              }
            />
            <Route
              path="/CargaEmpresa"
              element={
                ((!show || userData.isLogged) && <CargaEmpresa />) ||
                ((show || !userData.isLogged) && <Navigate to="/" />)
              }
            />
            <Route
              path="/Perfil"
              element={
                ((!show || userData.isLogged) && <Perfil />) ||
                ((show || !userData.isLogged) && <Navigate to="/" />)
              }
            />
            <Route path="/:vefrek_website" element={<PaginaEmpresa />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
        <VefiChatGlobal />
        <Footer />
      </NextUIProvider>
    </BrowserRouter>
  );
}

export default App;
